import styled from 'styled-components';
import {Typography, Form} from 'antd';
import {Button} from '../../ui-kit/Button';
import trees from '../../ui-kit/icons/treesgold.svg';
import {Footer} from '../../ui-kit/AppLayout/Footer';
import {Media} from '../../ui-kit/theme/breakpoints';
const {Text} = Typography;
import {LinkButton} from '../../ui-kit/Button';
import {themes} from '../../ui-kit/theme/theme';

export const PageWrapper = styled.div`
  width: 100%;
  background-color: ${({theme}) => theme.palette.background.white};
  display: flex;
  box-sizing: border-box;
  flex-direction: row;
  min-height: 100vh;
  font-family: Proxima Nova;
  ${Media.down.l} {
    flex-direction: column;
    min-height: unset;
    height: 100%;
    background-image: url(${trees});
    background-size: 91px 158px;
    background-repeat: no-repeat;
    background-position: 94% 91%;
  }
`;

export const MagicLinkFormContainer = styled.div`
  margin-top: 90px;
  width: 100%;
  display: flex;
  justify-content: center;
  ${Media.down.l} {
    margin-top: 15px;
  }
`;

export const MagicLinkFormWrapper = styled(Form)`
  width: 100%;
  max-width: 375px;
`;

export const FormTitle = styled(Text)`
  font-family: Majesti Banner;
  font-size: 24px;
  font-weight: ${({theme}) => theme.font.weight.mediumBold};
  line-height: 32px;
`;

export const SubmitBtn = styled(Button).attrs({
  type: 'primary',
})`
  width: 205px;
  margin-top: 10px;
  height: 38px;
  font-size: 16px;
  font-weight: ${({theme}) => theme.font.weight.regular};
  opacity: 1;
  :disabled {
    color: ${({theme}) => theme.palette.common.white};
    background: ${({theme}) => {
      if (theme.current === themes.coke) return theme.palette.background.black;
      if (theme.current === themes.lite) return theme.palette.background.black;
      return theme.palette.common.brown;
    }};
    opacity: 0.8;
  }
  ${Media.down.l} {
    display: block;
  }
`;

export const SuccessBlockWrapper = styled.div`
  width: 100%;
  max-width: 370px;
  padding-top: 20px;
`;

export const SuccessTitle = styled(Text)`
  font-family: Majesti Banner;
  font-size: 24px;
  line-height: 32px;
  font-weight: ${({theme}) => theme.font.weight.mediumBold};
  margin-bottom: 12px;
  display: block;
`;

export const DescrText = styled(Text)`
  font-size: 14px;
  line-height: 22px;
  display: block;
  margin-top: 8px;
  margin-bottom: 24px;
`;

export const LoaderWrapper = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  margin-top: 200px;
`;

export const LogoSectionTitle = styled(Text)`
  &.ant-typography {
    font-family: 'Majesti Banner';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    text-transform: capitalize;
    background: linear-gradient(
      360deg,
      #b9976a 0%,
      #c8ab78 11.46%,
      #e4d19d 33.33%,
      #f9ecc8 52.08%,
      #e4d19d 68.23%,
      #d8c288 85.42%,
      #d4b67a 100%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
    margin-top: 12px;
  }
`;

export const RightPart = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  & footer {
    position: absolute;
    bottom: 0;
    left: 0;
  }
  ${Media.down.l} {
    padding: 0px 15px 80px 15px;
    height: 100%;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

export const FooterWrapper = styled(Footer)`
  height: 20px;
  padding-bottom: 0;
  background-color: transparent;
  border: none;
  margin-bottom: 16px;
`;

export const ErrorLine = styled.div`
  color: ${({theme}) => theme.palette.common.redBrown};
`;

export const StyledLine = styled.div`
  position: relative;
  border-bottom: 1px solid #9a9fa2;
  margin: 34px 0;
`;

export const StyledOr = styled.span`
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0 24px;
  background-color: ${({theme}) => theme.palette.common.white};
  font-family: 'Proxima Nova';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #141414;
`;

export const LoginLinkButton = styled(LinkButton)`
  width: 174px;
  height: 40px;
  background-color: transparent;
  font-family: 'Proxima Nova';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #495258;
  ${Media.down.l} {
    display: block;
  }
`;
